var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"text-center"},[_vm._v(" The page timed out while loading. Are you sure you're still connected to the Internet? ")])
}
var staticRenderFns = []

export { render, staticRenderFns }